<template>
	<div class="dialog-timer">
		<h1>{{ timer }}</h1>
	</div>
</template>

<script>
	export default {
		name: 'dialog-timer',
		data() {
			return {
				timer: 3,
			};
		},
		watch: {
			timer(val) {
				if (val === 1) {
					setTimeout(() => {
						this.$modal.close();
					}, 1000);
				}
			},
		},
		mounted() {
			const timer = setInterval(() => {
				this.timer -= 1;
				if (this.timer === 1) clearInterval(timer);
			}, 1000);
		},
	};
</script>

<style lang="scss">
	.dialog-timer {
		@extend %layout-flex-center-y;
		background-color: color('deep-ocean-blue');
		width: 100%;
		padding: 27px 148px;
		color: color('soft-cream');
	}
</style>
